import * as $ from '../../dom-helper';

import RequestPromise from 'request-promise-native';
import TingleModal from 'tingle.js';

export default class ItemShow {
  constructor() { }

  initialize() {
    
    // Because we're using data-action as our selectors, we should move this
    // into the application initializer since it doesn't necesarilly applies
    // just to this function anymore
    //
    let selectors = document.querySelectorAll('[data-action]');
    
    document.addEventListener('click', (event) => {
      selectors.forEach((element, index) => {
  
        // console.log(element)
        
        // element.addEventListener('click', (event) => {
        //   console.log('a')
        //   console.log(event)
        //   console.log('b')
        // })

        if (event.target == element) {
          event.stopPropagation();
          event.preventDefault();          

          let attributes = element.dataset;

          if (attributes.action == 'addNote()') {
            this.addNote(attributes.url)
          }

          if (attributes.action == 'closeModal()') {
            this.closeModal()
          }

        }
      });
    });

    // Condition tooltip: append tooltip to <body> so it isn't clipped by cards/containers.
    // Keeps existing markup intact (span.condition-tooltip-trigger > span.condition-tooltip-text),
    // but temporarily moves tooltip into document.body on hover.
    this.initializeConditionTooltipPortal();
  }

  initializeConditionTooltipPortal() {
    const triggers = document.querySelectorAll('.condition-tooltip-trigger');
    if (!triggers || triggers.length === 0) return;

    // Avoid double-binding if initialize() runs multiple times.
    triggers.forEach((trigger) => {
      if (trigger.dataset.tooltipPortalBound === '1') return;
      trigger.dataset.tooltipPortalBound = '1';

      const tooltip = trigger.querySelector('.condition-tooltip-text');
      if (!tooltip) return;

      // Save original placement so we can restore it.
      const originalParent = tooltip.parentNode;
      const originalNextSibling = tooltip.nextSibling;

      const positionTooltip = () => {
        const rect = trigger.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        // Default: above icon, centered.
        let top = rect.top - tooltipRect.height - 10;
        let left = rect.left + rect.width / 2 - tooltipRect.width / 2;

        // Clamp to viewport with some padding.
        const padding = 8;
        left = Math.max(padding, Math.min(left, window.innerWidth - tooltipRect.width - padding));
        top = Math.max(padding, Math.min(top, window.innerHeight - tooltipRect.height - padding));

        tooltip.style.position = 'fixed';
        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
        tooltip.style.bottom = 'auto';
        tooltip.style.marginLeft = '0';
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '1';
        tooltip.style.pointerEvents = 'none';
      };

      const show = () => {
        // Move tooltip to body so it can overflow freely.
        if (tooltip.parentNode !== document.body) {
          document.body.appendChild(tooltip);
        }

        // Need a frame so tooltip has correct dimensions after moving.
        requestAnimationFrame(() => positionTooltip());
      };

      const hide = () => {
        tooltip.style.visibility = 'hidden';
        tooltip.style.opacity = '0';

        // Restore back into original DOM position.
        if (originalParent) {
          if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
            originalParent.insertBefore(tooltip, originalNextSibling);
          } else {
            originalParent.appendChild(tooltip);
          }
        }
      };

      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('mouseleave', hide);
      window.addEventListener('scroll', hide, true);
      window.addEventListener('resize', hide);
    });
  }

  addNote(uri) {
    let uriOptions = {
      method: 'GET',
      uri: uri,
      responseType: 'json',
      headers: {
        'Accept': 'text/javascript',
        'Content-Type': 'text/javascript',
        'X-CSRF-Token': this.getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    RequestPromise(uriOptions).then((response) => {
      this.modal(response, uri)
    }).catch((error) => {
      console.error(error)
    });
  }


  modal(content, uri, modalType = 'page') {
    this.modalWindow = new TingleModal.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: 'Close',
      cssClass: [modalType],
      onOpen: () => { },
      beforeClose: () => {
        return true;
        return false;
      },
      onClose: () => {
        this.closeModal()
      }
    });

    this.modalWindow.setContent(content);
    this.modalWindow.open();
  }

  closeModal() {
    this.modalWindow.destroy()
  }

  getCSRFToken() {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
      const meta = metas[i];

      if (meta.getAttribute('name') === 'csrf-token') {
        return meta.getAttribute('content');
      }
    }

    return null
  }
}